export const shadows = {
  none: "none",
  xs: "0 1px 2px rgba(0,0,0,0.2)",
  sm: "0 2px 8px rgba(0,0,0,0.25)",
  md: "0 4px 16px rgba(0,0,0,0.3)",
  lg: "0 8px 28px rgba(0,0,0,0.35)",
  xl: "0 16px 48px rgba(0,0,0,0.45)",
  focus: "0 0 0 3px var(--tra-color-focus-ring)",
  hover: "0 6px 20px rgba(52,199,123,0.28)",
  overlay: "0 24px 64px rgba(0,0,0,0.55)",
};

/** Softer elevation for premium light surfaces (player platform). */
export const lightShadows = {
  none: "none",
  xs: "0 1px 2px rgba(15, 23, 42, 0.04)",
  sm: "0 1px 3px rgba(15, 23, 42, 0.06), 0 4px 12px rgba(15, 23, 42, 0.04)",
  md: "0 4px 16px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.04)",
  lg: "0 12px 32px rgba(15, 23, 42, 0.1), 0 4px 12px rgba(15, 23, 42, 0.05)",
  xl: "0 20px 48px rgba(15, 23, 42, 0.12)",
  focus: "0 0 0 3px var(--tra-color-focus-ring)",
  hover: "0 8px 24px rgba(31, 157, 92, 0.18)",
  overlay: "0 24px 64px rgba(15, 23, 42, 0.16)",
};
